import React, {FC, PropsWithChildren} from 'react';

import {
  DropdownItem,
  DropdownItemProps,
} from '../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {PermissionCheck, PermissionCheckProps} from '../../../../srcCommon/permissions/permissionCheck';

/*
 * Props.
 */

export interface PermissionDropdownItemProps extends DropdownItemProps, PermissionCheckProps {}

/*
 * Component.
 */

export const PermissionDropdownItem: FC<PropsWithChildren<PermissionDropdownItemProps>> = ({
  namespaces,
  permission,
  offlinePermission,
  bulkActionPermission,
  ...props
}) => (
  <PermissionCheck
    namespaces={namespaces}
    permission={permission}
    offlinePermission={offlinePermission}
    bulkActionPermission={bulkActionPermission}
  >
    {(permissionResult) => (
      <DropdownItem {...props} isDisabled={props.isDisabled || !permissionResult.isAllowed}>
        {props.children}
      </DropdownItem>
    )}
  </PermissionCheck>
);
